import { render, staticRenderFns } from "./CentralReservas.vue?vue&type=template&id=08093b2b"
import script from "./CentralReservas.vue?vue&type=script&lang=js"
export * from "./CentralReservas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports